import { render, staticRenderFns } from "./PaymentMethods.vue?vue&type=template&id=93dac616&scoped=true"
import script from "./PaymentMethods.vue?vue&type=script&lang=js"
export * from "./PaymentMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93dac616",
  null
  
)

export default component.exports